import { withForm } from '@/components/form';
import { Field, Input, SectionCard } from '@/components/ui';
import { parseSocialUrl } from '@/utils/socialUrl';

import type { SocialProfileFormItem , socialPlatformEnum } from '../../contactSchema';
import { defaultFormValues } from '../../contactSchema';
import { AddItemButton, RepeaterItem } from './RepeaterItem';

const PLATFORM_OPTIONS = [
  { value: '', label: '—' },
  { value: 'linkedin' as const, label: 'LinkedIn' },
  { value: 'twitter' as const, label: 'Twitter / X' },
  { value: 'facebook' as const, label: 'Facebook' },
  { value: 'instagram' as const, label: 'Instagram' },
  { value: 'github' as const, label: 'GitHub' },
] satisfies { value: (typeof socialPlatformEnum.options)[number]; label: string }[];

const empty = (): SocialProfileFormItem => ({ platform: '', url: '', username: '' });

export const SocialProfilesSection = withForm({
  defaultValues: defaultFormValues,
  render: function SocialProfilesSection({ form }) {
    return (
      <SectionCard
        title="Social profiles"
        actions={<AddItemButton onClick={() => form.pushFieldValue('contact.socialProfiles', empty())} />}
      >
        <form.AppField name="contact.socialProfiles">
          {(field) => (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {(field.state.value ?? []).map((_, i) => (
                <RepeaterItem key={i} onRemove={() => field.removeValue(i)} removeLabel="Remove social profile">
                  <div className="ds-form-grid-3">
                    <form.AppField name={`contact.socialProfiles[${i}].url`}>
                      {(f) => (
                        <Field label="URL">
                          <Input
                            placeholder="https://linkedin.com/in/..."
                            value={f.state.value ?? ''}
                            onChange={(e) => f.handleChange(e.target.value)}
                            onBlur={() => {
                              f.handleBlur();
                              const url = f.state.value;
                              if (!url) return;
                              const parsed = parseSocialUrl(url);
                              if (!parsed) return;
                              const platform = form.getFieldValue(`contact.socialProfiles[${i}].platform`);
                              const username = form.getFieldValue(`contact.socialProfiles[${i}].username`);
                              if (!platform) {
                                form.setFieldValue(`contact.socialProfiles[${i}].platform`, parsed.platform);
                              }
                              if (!username) {
                                form.setFieldValue(`contact.socialProfiles[${i}].username`, parsed.username);
                              }
                            }}
                          />
                        </Field>
                      )}
                    </form.AppField>
                    <form.AppField name={`contact.socialProfiles[${i}].platform`}>
                      {(f) => <f.Select label="Platform" options={PLATFORM_OPTIONS} />}
                    </form.AppField>
                    <form.AppField name={`contact.socialProfiles[${i}].username`}>
                      {(f) => <f.TextField label="Username" />}
                    </form.AppField>
                  </div>
                </RepeaterItem>
              ))}
            </div>
          )}
        </form.AppField>
      </SectionCard>
    );
  },
});
